import firebase from "acciondigital-basic-theme/src/utils/get-firebase-instance"
import { crearEventoBase } from "acciondigital-commons/site-events-commons"


export const frdbe = (siteId, eventoInfo, options) => crearEventoBase(firebase, siteId, eventoInfo, options)

/**
 * Sends a Google Analytics event using the gtag function if available and conditions are met.
 *
 * @param {string} evento - The name of the event to send.
 * @param {boolean} [condicion=true] - Condition to determine if the event should be sent.
 * @param {Object} [parametros] - Additional parameters to send with the event.
 */
export const gtage = (evento, condicion = true, parametros) => {
  try {
    typeof window?.gtag !== "undefined" &&
      evento &&
      condicion &&
      window.gtag("event", evento, { ...(parametros ?? {}) })
    // console.debug("🚀 ~ file: gatgUtils.js:4 ~ gtage ~ ", {evento, condicion, parametros})
    
  } catch (error) {
    console.debug(error.message)
  }
}

export const listasZ = {
  USUARIOS:
    // "3ze88eef0778d64e96606fb33c42f439900b1beffd76c5a95e70853abd033039c2",
    "3ze88eef0778d64e96606fb33c42f439900b1beffd76c5a95e70853abd033039c2",
  CLIENTES:
  // "3ze88eef0778d64e96606fb33c42f43990c9fe51bbaa54efb89b9167dc8882d8a9",
  "3z57d1140894fec44836b7085a3cf7d56ab35d31e18e42df75ea77c0bb24b10357",
}

const valListasZ = Object.values(listasZ).reduce((obj, v) => {
  obj[v] = v
  return obj
}, {})
// {
//   [listasZ.USUARIOS]: listasZ.USUARIOS,
//   [listasZ.CLIENTES]: listasZ.CLIENTES,
// }

export const zSubscribe = (email, lista = "", condicion = true) => {
  // console.debug("🚀 ~ file: gatgUtils.js:22 ~ zSubscribe ~ email", {email, lista, valListasZ:valListasZ[lista]})
  try {
    typeof window?.waListSubscribe !== "undefined" &&
      lista &&
      valListasZ[lista] &&
      condicion &&
      window.waListSubscribe({ "Contact Email": email }, lista)
    console.debug("🚀 ~ file: gatgUtils.js:29 ~ zSubscribe ~ email", {
      email,
      lista,
      valListasZ: valListasZ[lista],
    })
  } catch (error) {
    console.debug(error.message)
  }
}

/**
 * Ejecuta la función `window.zcAction` con el evento proporcionado si existe y la condición es verdadera.
 *
 * La funcionalidad `window.zcAction` en Zoho se utiliza para el seguimiento de acciones en aplicaciones web, especialmente en el contexto de Zoho MarketingHub y Web Assistant. Permite registrar eventos específicos, como clics en botones, para analizar el comportamiento del usuario.
 *
 * @param {string} evento - Nombre o identificador del evento que se pasa a `window.zcAction`.
 * @param {boolean} [condicion=true] - Condición opcional que debe ser verdadera para ejecutar la acción.
 * @returns {void}
 */
export const zAction = (evento, condicion = true) => {
  // console.debug("🚀 ~ file: gatgUtils.js:22 ~ zSubscribe ~ email", {email, lista, valListasZ:valListasZ[lista]})
  try {
    /* typeof window?.zcAction !== "undefined" &&
      evento &&
      condicion &&
      window.zcAction(evento)
    console.debug("🚀 ~ file: gatgUtils.js:51 ~ constzAction ~ evento", {
      typeofStr: typeof window?.zcAction,
      condicion: typeof window?.zcAction !== "undefined" && evento && condicion,
      evento,
    }) */
    if(condicion) {
      // console.log({evento}, window.pagesense)
      window.pagesense = window.pagesense||[];
      window.pagesense.push(['trackEvent', evento]);
    }
    console.debug("🚀 ~ file: gatgUtils.js:51 ~ constzAction ~ evento", {
      typeofStr: typeof window.pagesense,
      condicion,
      evento,
    })
  } catch (error) {
    console.debug(error.message)
  }
}

export const zIdentifyUser = (email, condicion = true) => {
  try {
    if(condicion) {
      window.pagesense = window.pagesense || [];
      window.pagesense.push(['identifyUser',email]);
    }
  } catch (error) {
    console.debug(error.message)
  }
}

/**
 * Logs an event to Firebase Analytics if available and conditions are met.
 *
 * @param {string} evento - The name of the event to log.
 * @param {boolean} [condicion=true] - Condition to determine if the event should be logged.
 * @param {Object} [parametros] - Additional parameters to include with the event.
 */
export const fae = (evento, condicion = true, parametros) => {
  try {
    typeof firebase?.analytics !== "undefined" &&
      evento &&
      condicion &&
      firebase.analytics().logEvent(evento, { ...(parametros ?? {}) })
  } catch (error) {
    console.debug(error.message)
  }
}
export const faeSetUserId = (userid, condicion = true) => {
  try {
    typeof firebase?.analytics !== "undefined" &&
      condicion &&
      firebase.analytics().setUserId(userid)
    console.debug("🚀 ~ file: gatgUtils.js:72 ~ faeSetUserId ~ userid", {
      typeofStr: typeof firebase?.analytics,
      condicion: typeof firebase?.analytics !== "undefined" && condicion,
      userid,
    })
  } catch (error) {
    console.debug(error.message)
  }
}
export const faeSetUserProperties = (userProperties, condicion = true) => {
  try {
    typeof firebase?.analytics !== "undefined" &&
      condicion &&
      firebase.analytics().setUserProperties(userProperties)
  } catch (error) {
    console.debug(error.message)
  }
}
